import { useEffect, useRef } from 'react'

// Hook same as useEffect, but don't call in first render
export function useUpdate(callback, dependencies) {
  const didMountRef = useRef(false)

  useEffect(() => {
    if (didMountRef.current) {
      return callback()
    } else {
      didMountRef.current = true
    }
  }, [dependencies])
}
